/** Landing Community Explorer — coherent fictional demo personas (local assets). */

import { DEMO_IDENTITIES } from '@/lib/demo-identities';

const {
  sophieLin,
  amaraOkonkwo,
  kenjiYamamoto,
  pacificHeritageMuseum,
  vancouverHeritageLab,
  coastalMemoryArchive,
} = DEMO_IDENTITIES;

export type LandingCommunityPost = {
  id: string;
  name: string;
  subtitle: string;
  title: string;
  excerpt: string;
  avatar: string;
  ownerType: 'individual' | 'institution';
  location: string;
  tags: [string, string, string][];
};

export const LANDING_COMMUNITY_POSTS: LandingCommunityPost[] = [
  {
    id: 'lc-001',
    name: sophieLin.name,
    subtitle: sophieLin.subtitle,
    title: 'First winter in Canada',
    excerpt:
      'Arrival milestones, language practice notes, and the community festival that made Vancouver feel like home.',
    avatar: sophieLin.avatar,
    ownerType: 'individual',
    location: 'Vancouver, BC',
    tags: [
      ['Achievement', '#D1FAE5', '#047857'],
      ['History', '#FEF3C7', '#B45309'],
    ],
  },
  {
    id: 'lc-002',
    name: amaraOkonkwo.name,
    subtitle: amaraOkonkwo.subtitle,
    title: 'Neighbor care during the storm',
    excerpt:
      'Supply runs, wellness check-ins, and a block-level response network documented with consent-based summaries.',
    avatar: amaraOkonkwo.avatar,
    ownerType: 'individual',
    location: 'Burnaby, BC',
    tags: [
      ['Hero', '#FEE2E2', '#B91C1C'],
      ['News', '#CFFAFE', '#0E7490'],
    ],
  },
  {
    id: 'lc-003',
    name: kenjiYamamoto.name,
    subtitle: kenjiYamamoto.subtitle,
    title: "Grandmother's kitchen lessons",
    excerpt:
      'Recipe cards, oral history clips, and intergenerational teaching moments preserved for the next generation.',
    avatar: kenjiYamamoto.avatar,
    ownerType: 'individual',
    location: 'Richmond, BC',
    tags: [
      ['History', '#FEF3C7', '#B45309'],
      ['Favorites / Products', '#FCE7F3', '#BE185D'],
    ],
  },
  {
    id: 'lc-004',
    name: pacificHeritageMuseum.name,
    subtitle: pacificHeritageMuseum.subtitle,
    title: 'Newcomer listening booth',
    excerpt:
      'Facilitated booth sessions transcribed for public discovery — privacy-safe summaries only, full records protected.',
    avatar: pacificHeritageMuseum.avatar,
    ownerType: 'institution',
    location: 'Vancouver, BC',
    tags: [
      ['History', '#FEF3C7', '#B45309'],
      ['Achievement', '#D1FAE5', '#047857'],
    ],
  },
  {
    id: 'lc-005',
    name: vancouverHeritageLab.name,
    subtitle: vancouverHeritageLab.subtitle,
    title: "Elders' memory circle",
    excerpt:
      'Consent-based publishing with institution-reviewed summaries and protected source material.',
    avatar: vancouverHeritageLab.avatar,
    ownerType: 'institution',
    location: 'East Vancouver, BC',
    tags: [
      ['Hero', '#FEE2E2', '#B91C1C'],
      ['News', '#CFFAFE', '#0E7490'],
    ],
  },
  {
    id: 'lc-006',
    name: coastalMemoryArchive.name,
    subtitle: coastalMemoryArchive.subtitle,
    title: 'Graduation journey wall',
    excerpt:
      'Cohort milestones, mentor letters, and verified programme completion highlights for public recognition.',
    avatar: coastalMemoryArchive.avatar,
    ownerType: 'institution',
    location: 'North Shore, BC',
    tags: [
      ['Performance', '#DBEAFE', '#1D4ED8'],
      ['Achievement', '#D1FAE5', '#047857'],
    ],
  },
];
